import { types } from "../types/types";

export const legalReducer = (state = {
    haAcceptat: null,
    document: null,
    error: false,
}, action) => {
    switch (action.type) {
        case types.legalHaAcceptat:
            return {...state,haAcceptat: action.contingut.haAcceptat,nif: action.contingut.nif,error: false}
        case types.legalAcceptar:
            return { ...state, haAcceptat: true, error: false }
        case types.legalDocumentVigent:
            return { ...state, document: action.contingut }
        case types.legalError:
            return { ...state, haAcceptat: false, error: true }
        case types.legalReset:
            return { haAcceptat: null, document: null, error: false }
        default:
            return state;
    }
}